<app-header></app-header>
<app-login *ngIf="showLogin" ></app-login>
<app-login-user-invited *ngIf="showLoginInvited" ></app-login-user-invited>
<app-loader></app-loader>
<app-btn-payment></app-btn-payment>

<router-outlet></router-outlet>